export default __webpack_public_path__ + "static/media/hero15.c70a6443.png";